import classNames from "classnames";
import { FC, forwardRef, useId } from "react";
import styles from "./CheckBox.module.css";

export type CheckBoxProps = Omit<React.ComponentPropsWithoutRef<"input">, "type"> & {
  label?: string;
};

const CheckBox: FC<CheckBoxProps> = forwardRef<HTMLInputElement, CheckBoxProps>(
  ({ label, className, ...rest }, ref) => {
    const id = rest.id || useId();

    return (
      <div className={classNames(styles.container, className)}>
        <input ref={ref} {...rest} id={id} type="checkbox" />
        {label && (
          <label className={styles.label} htmlFor={id}>
            {label}
          </label>
        )}
      </div>
    );
  },
);

export default CheckBox;
